import Layout from '@/layout/layout'

const oldPhonereceived = {
  path: '/oldPhonereceived',
  component: Layout,
  redirect: 'noRedirect',
  name: '旧机收货',
  children: [
    {
      path: 'receivRecord',
      component: () => import('@/views/oldPhonereceived/receivRecord/index'),
      name: '收货记录',
      meta: { title: '收货记录', noCache: true }
    },
    {
      path: 'receivRecordDetail',
      component: () => import('@/views/oldPhonereceived/receivRecordDetail/index'),
      name: '收货记录详情',
      meta: { title: '收货记录详情', noCache: true }
    },
    {
      path: 'bulkReceiving',
      component: () => import('@/views/oldPhonereceived/bulkReceiving/index'),
      name: '批量收货',
      meta: { title: '批量收货', noCache: true }
  }
  ]
}

export default oldPhonereceived